function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";

var ClickOutside = function (_Component) {
  _inherits(ClickOutside, _Component);

  function ClickOutside() {
    var _temp, _this, _ret;

    _classCallCheck(this, ClickOutside);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.setRef = function (ref) {
      _this.container = ref;
    }, _this.handle = function (e) {
      var onClickOutside = _this.props.onClickOutside;

      var el = _this.container;
      if (!el.contains(e.target)) onClickOutside(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ClickOutside.prototype.componentDidMount = function componentDidMount() {
    var isActive = this.props.isActive;

    if (isActive) {
      this.addListener();
    }
  };

  ClickOutside.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var isActive = this.props.isActive;

    if (prevProps.isActive !== isActive) {
      if (isActive) {
        this.addListener();
      } else {
        this.removeListener();
      }
    }
  };

  ClickOutside.prototype.componentWillUnmount = function componentWillUnmount() {
    var isActive = this.props.isActive;

    if (isActive) {
      this.removeListener();
    }
  };

  ClickOutside.prototype.addListener = function addListener() {
    document.addEventListener("click", this.handle, true);
  };

  ClickOutside.prototype.removeListener = function removeListener() {
    document.removeEventListener("click", this.handle, true);
  };

  ClickOutside.prototype.render = function render() {
    var setRef = this.setRef,
        props = this.props;
    var children = props.children;

    return children({ setRef: setRef });
  };

  return ClickOutside;
}(Component);

ClickOutside.defaultProps = {
  isActive: true
};

ClickOutside.propTypes = process.env.NODE_ENV !== "production" ? {
  isActive: PropTypes.bool.isRequired,
  onClickOutside: PropTypes.func.isRequired
} : {};

export default ClickOutside;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/click-outside/ClickOutside.js
// module id = null
// module chunks = 